import { JsAudioDevice, PortAudioMessage } from '../dualChannelTypes';
import loadWorklets from './loadWorklets';
import { deleteInstance, setInstance } from './state';

export async function startStreaming(device: JsAudioDevice): Promise<MediaStream> {
  if (!window.audioAPI) throw new Error('Audio API not available');
  const port1 = window.audioAPI.startStreaming(device);

  const ctx = new (window.AudioContext || (window as any).webkitAudioContext)({ sampleRate: device.sampleRate });
  await loadWorklets(ctx);

  // Node 2: your existing PCM processor that consumes messages { pcmData }
  const worklet = device.channels === 2 ? 'pcm-processor-stereo' : 'pcm-processor-mono';
  const pcmNode = new AudioWorkletNode(ctx, worklet, {
    numberOfInputs: 0,
    numberOfOutputs: 1,
    outputChannelCount: [device.channels],
    // processorOptions: { targetLatencyMs: 30 },
  });
  const dest = new MediaStreamAudioDestinationNode(ctx);
  pcmNode.connect(dest);

  const { stream } = dest;

  const track = stream.getAudioTracks()[0];

  // Ensure stop command is sent when the track stops (e.g., consumer calls track.stop())
  function sendStop() {
    stopStreaming(device.id);
  }
  const originalStop = track.stop.bind(track);
  (track as any).stop = () => { try { sendStop(); } finally { originalStop(); } };

  // Also send stop if context closes
  ctx.addEventListener('statechange', () => {
    if (ctx.state === 'closed') sendStop();
  });

  setInstance(device.id, {
    ctx, dest, pcmNode, stream,
  });

  port1.onmessage = (event: MessageEvent<PortAudioMessage>) => {
    const { data } = event;
    if (data && data.type === 'audio-chunk') {
      const float32 = new Float32Array(
        data.payload,
        0,
        data.payload.byteLength / 4,
      );
      pcmNode.port.postMessage({ pcmData: float32 }, [float32.buffer]);
    }
  };
  (port1 as any).start?.();

  return stream;
}

export async function stopStreaming(deviceId: string) {
  window.audioAPI.stopStreaming(deviceId);
  deleteInstance(deviceId);
}
